import firebase from "firebase";
const state = []


const actions = {	
	getOne({commit}, id){
		var subscription = firebase.firestore().doc(`surveys/${id}`).onSnapshot(doc => {
			var user =  doc.data();
			user.id = doc.id;
			commit("SET_ONE",  {doc: user, collection: "surveys"}, {root:true} )
		})
		commit("auth/LOG_SUBSCRIPTION", subscription, {root: true})
	},
	getAll({ commit }){
		var subscription = firebase.firestore().collection("surveys").onSnapshot(snap => {
			snap.forEach( doc => {
				var user = doc.data()
				user.id = doc.id;
				commit("SET_ONE",  {doc: user, collection: "surveys"}, {root:true} )  
			})
		});
		commit("auth/LOG_SUBSCRIPTION", subscription, {root: true})

	},	
} 

const mutations = {

}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
